export default function Hero() {
  const stats = [
    { value: '20,000+', label: '部漫画资源' },
    { value: '每日 100+', label: '章节同步更新' },
    { value: '99.9%', label: '服务稳定在线' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-5">
              日漫 · 韩漫 · 国漫全免费
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              哔咔动漫 - 免费漫画全集下拉式在线阅读
            </h1>

            <p className="text-lg md:text-xl text-foreground-700 mb-3 font-medium">
              海量资源，一键畅读，永远免费
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              哔咔动漫致力于打造最全免费漫画在线阅读平台，涵盖日漫、韩漫、国漫等各类热门作品。
              支持流畅的下拉式阅读体验，无付费限制、无广告打扰。每日同步更新最新连载，
              热门完结作品一网打尽，是你追更看漫的最佳选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {s.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                开始免费阅读
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20dynamic%20illustration%20of%20manga%20reading%20experience%20with%20colorful%20floating%20comic%20panels%20featuring%20action%20scenes%20and%20characters%20in%20Japanese%20anime%20art%20style%2C%20warm%20coral%20and%20orange%20energy%20bursts%2C%20speech%20bubbles%20with%20Japanese%20text%2C%20speed%20lines%20and%20halftone%20patterns%2C%20dark%20dramatic%20background%20with%20pop%20art%20elements%2C%20modern%20web%20illustration%20with%20high%20contrast%20and%20rich%20saturation&width=800&height=600&seq=hero-manga-visual&orientation=landscape"
                alt="哔咔动漫免费下拉式在线阅读主视觉 - 日漫韩漫全免费海量资源"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}